import React from 'react';
import { motion } from 'framer-motion';
export function PainPointSection() {
  return <section className="bg-gradient-to-b from-[#1a0f0f] to-[#2C1810] py-10 px-4" data-id="element-137">
      <div className="max-w-3xl mx-auto text-center" data-id="element-138">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-white uppercase mb-8 leading-tight" data-id="element-139">
          SI AÚN NO ESTÁS SEGURO, QUIZÁS ESTO TE SUENE FAMILIAR…
        </motion.h2>

        <div className="w-16 h-1 bg-[#D4726A] mx-auto mb-8 rounded-full opacity-50" data-id="element-140"></div>

        <div className="space-y-6 text-lg md:text-xl text-[#F4F4F2] font-medium leading-relaxed" data-id="element-141">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-142">
            Si eres docente de Historia, probablemente conoces esta sensación.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-143">
            Empieza el año escolar y sabes que te esperan horas y horas
            preparando materiales.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-wrap justify-center gap-3 py-4" data-id="element-144">
            <span className="bg-[#D4726A]/20 text-[#E8A49C] rounded px-4 py-2 font-bold border border-[#D4726A]/30 shadow-[0_0_15px_rgba(212,114,106,0.1)]" data-id="element-145">
              Buscar textos.
            </span>
            <span className="bg-[#D4726A]/20 text-[#E8A49C] rounded px-4 py-2 font-bold border border-[#D4726A]/30 shadow-[0_0_15px_rgba(212,114,106,0.1)]" data-id="element-146">
              Inventar actividades.
            </span>
            <span className="bg-[#D4726A]/20 text-[#E8A49C] rounded px-4 py-2 font-bold border border-[#D4726A]/30 shadow-[0_0_15px_rgba(212,114,106,0.1)]" data-id="element-147">
              Armar diapositivas.
            </span>
            <span className="bg-[#D4726A]/20 text-[#E8A49C] rounded px-4 py-2 font-bold border border-[#D4726A]/30 shadow-[0_0_15px_rgba(212,114,106,0.1)]" data-id="element-148">
              Organizar contenidos.
            </span>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-149">
            Muchas veces todo esto sucede fuera del horario laboral, en casa, de
            noche o durante el fin de semana.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-150">
            Y aun así queda la sensación de que siempre falta algo por preparar.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} data-id="element-151">
            No porque falten ganas de enseñar bien.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="mt-8 p-6 border-l-4 border-[#D4726A] bg-white/5 rounded-r-lg text-left" data-id="element-152">
            <p className="text-2xl md:text-3xl font-bold text-[#E8A49C] leading-tight" data-id="element-153">
              Sino porque la realidad es que un docente no debería tener que
              crear todo desde cero cada año.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}